import { StaticImplements, Factory } from './utils';

export class Address {
  cep: string;

  place: string;

  neighborhood: string;

  number: string;

  city: string;

  uf: string;

  complement: string;
}

export class Responsible {
  name: string;

  phone: string;

  email: string;
}

export class Company {
  id: number;

  publicKey: string;

  name: string;

  fantasy: string;

  type: 'f' | 'j';

  document: string;

  status: number;

  phone: string;

  ie: string;

  im: string;

  responsible: Responsible;

  address: Address;
}

export declare class User {
  id: number;

  publicKey: string;

  name: string;

  email: string;

  image: string;

  token: string;
}

export type UserSession = User & {
  authenticated: boolean;
};

@StaticImplements<Factory<Session>>()
export class Session {
  user: UserSession;

  client: Company;

  company: Company;

  companies: Array<Company>;

  constructor() {
    this.user = { authenticated: false } as UserSession;
    this.client = this.company = {} as Company;
    this.companies = new Array<Company>();
  }

  static fromJson(json: Partial<Session>): Session {
    const session = new Session();
    session.user = json.user;
    session.client = json.client;
    session.companies = json.companies;
    session.company = json.company;
    return session;
  }
}
